__turbopack_context__.v({
  "className": "abril_fatface_48e4465a-module__PPfWNq__className",
  "variable": "abril_fatface_48e4465a-module__PPfWNq__variable",
});
